export default "__VITE_ASSET__DU30B91U__"